import * as React from 'react';
import { Component, CSSProperties, ReactNode } from 'react';
import * as classNames from 'classnames';

interface IOnScreenProps {
  className?: string;
  style?: CSSProperties;
}
interface IOnScreenContainerInjectedProps {
  isOnScreen: boolean;
  onShowNewsList: () => void;
  exposureFunction: () => void;
}
interface IOnScreenContainerState {
  hasLog: boolean;
}

export default class OnScreenContainer extends React.Component<IOnScreenProps, IOnScreenContainerState> {
  constructor(props) {
    super(props);
    this.state = {
      hasLog: false,
    };
  }

  public get injected(): IOnScreenContainerInjectedProps {
    return this.props as IOnScreenContainerInjectedProps;
  }

  public componentDidMount(): void {
    if (this.state.hasLog === false && this.injected.isOnScreen) {
      this.injected.exposureFunction();
    }
  }

  public render() {
    return (
      <div style={{ position: 'absolute', top: 0, bottom: 0 }} />
    );
  }
}
